<template>
  <b-container fluid class="mt-2 px-1 px-sm-3 pb-3 maintenance-page">
      <b-row>
          <b-col cols="" class="">
              <router-view />
          </b-col>
      </b-row>
  </b-container>
</template>
<script>
export default {
  name: "Maintenance",
  data() {
      return {
      }
  },

}
</script>
<style>
.bi-x.cross_icon {
    position: absolute;
    right: 10px !important;
    top: 42px !important;
    width: 8px;
    cursor: pointer;
    fill: #000;
}

.maintenance h4 {
    font-size: 18px !important;
    color: var(--black);
    font-weight: 600;
    margin-top: 20px;
}

.maintenance #__BVID__45___BV_tab_button__ {
    width: 292px;
    margin-right: 0;
}

.maintenance #__BVID__18___BV_tab_button__ {
    width: 212px !important;
}

.maintenance #maintenance-modalexample-datepicker {
    display: none;
}

.maintenance fieldset {
    width: 100%;
    font-size: var(--extrasmall) !important;
}

.record {
    font-size: var(--small) !important;
}

.due_date .date {
    width: 227px !important;
    margin-right: 25px !important;
}

.due_date .desc {
    width: -webkit-fill-available !important;
}

.desc textarea {
    background-color: #f5f5f5 !important;
}

.modal-content .vs__dropdown-toggle {
    min-height: 40px;
}

.upload-btn-wrapper {
    width: 100%;
}

.upload-btn-wrapper .foo {
    width: 100% !important;
}

@media (min-width: 576px) {
    .modal-dialog {
        max-width: 631px !important;
        width: 631px !important;
    }
}

.maintenance-page .vs__dropdown-menu {
    min-width: 150px !important;
}

.modal .form-control {
    font-size: var(--extrasmall) !important;
    padding-right: 0;
    /* display: flex; */
    align-items: center;
}

.b-form-btn-label-control.form-control>.btn {
    padding-right: 5px;
    padding-left: 5px;
}

.b-form-btn-label-control.form-control>.form-control {
    padding-left: 0 !important;
    padding-right: 20px;
    font-size: 11px !important;
    padding-top: 8px;
    text-transform: capitalize;
    line-height: 14px;
}

.form-control:focus {
    box-shadow: unset;
}

@media (max-width: 1560px) {
    .b-form-btn-label-control.form-control>.form-control {
        font-size: 12px !important;
        font-weight: 500;
    }
}

@media (max-width: 991px) {
    .maintenance .card-text {
        overflow-x: scroll;
    }

    .maintenance #__BVID__45___BV_tab_button__,
    .maintenance #__BVID__18___BV_tab_button__ {
        width: auto !important;
    }
}

@media (max-width: 575px) {
    .due_date.d-flex {
        display: block !important;
    }
}
</style>